import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfigWebsitPouyan";
import sampleData from './sampledata.json';
import { notificationAlertErrorApi } from "../../../components/method/notificationAlertErrorApi/notificationAlertErrorApi";

export const actionTypes = {
  selectSlider: "[selectSlider] Action",
  selectSliderEmpty: "[selectSliderEmpty] Action",
  selectSliderAsync: "[selectSliderAsync] Action",
  selectSliderLoading: "[selectSliderLoading] Action",
}

const initialState = {
  // data: sampleData ? sampleData : [],
  data: [],
  size: 20,
  total: 10000,
  loading: false
}


export const select_slider_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.selectSlider:
      return {
        ...state,
        data: payload.results,
        total: payload.total ? payload.total : state.total
      };
    case actionTypes.selectSliderLoading:
      return {
        ...state,
        loading: payload,
      };
    case actionTypes.selectSliderEmpty:
      return initialState
    default:
      return state;
  }
}



function* handleWorker({ payload }) {

  const config = {
    // url: `/SliderCategory/GetSliderCategoryDetails/GetSliderCategoryDetails/2`,
    url: `/SliderCategory/GetSliderCategoryDetails/2`,
    method: "GET"
  };

  const data = {
    ...payload?.data
  };

  const header = {
    ...payload?.headers
  }
  yield put({ type: actionTypes.selectSliderLoading, payload: true })
  try {
    let res = yield AxiosCustom(config, data, header)

    if (res?.data)
      // yield put({ type: actionTypes.selectSlider, payload: { results: sampleData.reverse(), total: sampleData?.length } })
    yield put({ type: actionTypes.selectSlider, payload: { results: res?.data?.data, total: res?.data?.data?.length } })

  } catch (error) {
    // yield put({ type: actionTypes.selectSlider, payload: { results: sampleData.reverse(), total: sampleData?.length } })
    notificationAlertErrorApi(error, payload?.dispatch)
  } finally {
    yield put({ type: actionTypes.selectSliderLoading, payload: false })
  }
}

export function* workerSelectSlider() {
  yield takeLatest(actionTypes.selectSliderAsync, handleWorker);
}


